import { gsap, useGSAP } from 'src/utils/gsap';
import { prefersReducedMotion } from 'src/utils/motion';

// Slides [data-reveal] elements up when they enter the viewport
const useReveal = (scope) => {
  useGSAP(
    () => {
      if (prefersReducedMotion) return;

      gsap.utils.toArray('[data-reveal]', scope.current).forEach((el) => {
        gsap.from(el, {
          y: 44,
          opacity: 0,
          duration: 1.3,
          ease: 'expo.out',
          scrollTrigger: { trigger: el, start: 'top 90%' }
        });
      });
    },
    { scope }
  );
};

export default useReveal;
